import React from 'react'
import { Container, Button } from 'layouts'
import SectionType from 'models/types/ts/sectionType'
import LanguageType from 'models/language-type'
import BackgroundImage from 'features/background-image'
import Hero from './components/hero'
import HowItWorks from './components/how-it-works'
import RecruiterRewards from './components/recruiter-rewards'
import RecruiterBenefits from './components/recruiter-benefits'
import TermsAndConditions from './components/recruit-shared/components/terms-and-conditions'
import RecruitAuthenticated from './components/recruit-authenticated'
import style from './RecruitMain.module.scss'

interface Props {
    loggedIn: boolean
    language: LanguageType
    hero: SectionType
    socialShare: SectionType
    howItWorks: SectionType
    recruiterRewards: SectionType
    recruiterBenefits: SectionType
    token: string // Not used in here, could be removed and then also where set
    hasContent: boolean // Not used in here, could be removed and then also where set
}

const Recruit = ({
    loggedIn,
    language,
    hero,
    socialShare,
    howItWorks,
    recruiterRewards,
    recruiterBenefits,
}: Props): JSX.Element => {
    return (
        <div className={style.recruit}>
            <BackgroundImage url="https://images.ctfassets.net/7lhcm73ukv5p/1mv6Tg8PUsMWyGauWckSOo/5be5f00d5fb6d445f420b7a1c669fd26/star-bg.jpg">
                <BackgroundImage
                    url="https://images.ctfassets.net/7lhcm73ukv5p/71qlaDd55GDvjCU6zSuzvw/2a6f9fdbc940b6b29e9ebdb8fbd685d5/recruit-bg-dark.jpg?q=75"
                    repeat="no-repeat"
                    size="cover"
                    position="center top"
                    className={style.header}
                >
                    <Hero section={hero} loggedIn={loggedIn} />
                </BackgroundImage>
                <Container>
                    {loggedIn && (
                        <RecruitAuthenticated
                            socialShareSection={socialShare}
                            language={language}
                        />
                    )}
                    <div className={style.content}>
                        <HowItWorks section={howItWorks} />
                        <RecruiterRewards section={recruiterRewards} />
                        <RecruiterBenefits section={recruiterBenefits} />
                        {!loggedIn && (
                            <div className={style.btn}>
                                <Button
                                    internal
                                    theme="recruit"
                                    path={{
                                        page: 'login',
                                        query: {
                                            path: `/${language}/recruit`,
                                        },
                                    }}
                                >
                                    {hero.buttonText}
                                </Button>
                            </div>
                        )}
                        <TermsAndConditions />
                    </div>
                </Container>
            </BackgroundImage>
        </div>
    )
}

export default Recruit
